import React,{useEffect,useState} from 'react'
import {getTopSeller} from 'network/ApiAxiosTickets'

function TopSeller() {
    const [TopSeller, setTopSeller] = useState(null);
    let role = JSON.parse(localStorage.getItem("user")).role;
    useEffect(() => {
        topSellerHandler()
    }, []);

    const topSellerHandler = async()=>{
        const resp = await getTopSeller()
        if(resp.data.success){
            setTopSeller(resp.data.topSeller)
            console.log(resp.data.topSeller)
        }
    }

  return (
    
      TopSeller &&
      <>
        <h2 className='text-center'>Tickets:  {role =="admin" ? TopSeller.Name + " - " + TopSeller.Tickets : TopSeller.Name}  </h2>
        <h2 className='text-center'>Money: { role =="admin" ? TopSeller.cashName + " - " + TopSeller.cashTotal + "€" : TopSeller.cashName}</h2>
      </>
      
    
  )
}

export default TopSeller